module.exports = __webpack_public_path__ + "static/media/remoteAuthNEVTemp.acf0f28e.xlsx";